import RangeSlider from 'react-range-slider-input'
import 'react-range-slider-input/dist/style.css'
import './styles.scss'

export interface RangePickerProps {
  minValue: number
  maxValue: number
  startValue: number
  endValue: number
  onValuesChanged: (values: number[]) => void
  disabled?: boolean
}

export const ZocksRangePicker = ({ minValue, maxValue, startValue, endValue, onValuesChanged, disabled }: RangePickerProps) => {
  return (
    <RangeSlider disabled={disabled} onInput={onValuesChanged} className={'zocks-range-picker'} min={minValue} max={maxValue} value={[startValue, endValue]} />
  )
}
